import { get, post, put } from '../utils/axios'

export const getProvidentFundAPI = async (param) => {
  return await get('pvds', param)
}

export const editProvidentFundAPI = async (param, body) => {
  return await put('pvds', param, body)
}

export const createProvidentFundAPI = async (body) => {
  return await post('pvds', body)
}

export const getProvidentFundEmpAPI = async (param) => {
  return await get('pvds/emp', param)
}

export const getProvidentStatusAPI = async () => {
  return await get('pvds/status')
}
